export type SlotType = {
  id: string;
  adUnitPath: string;
  size: googletag.GeneralSize;
  refresh?: boolean;
  isLazyLoaded?: boolean;
};

export type SlotConfigType = {
  Startpage: {
    [key: string]: SlotType;
  };
  Profile: {
    [key: string]: SlotType;
  };
  Login: {
    [key: string]: SlotType;
  };
};

export const adSlotConfig: SlotConfigType = {
  Startpage: {
    Billboard: {
      id: 'div-gpt-ad-1407836097008-0',
      adUnitPath: '/53015287,23277432748/xing.com_d_970x250_1',
      size: [
        [970, 250],
        [800, 250],
        [728, 90],
        [970, 90],
      ],
    },
    Leaderboard: {
      isLazyLoaded: true,
      id: 'div-gpt-ad-1407836042875-0',
      adUnitPath: '/53015287,23277432748/xing.com_d_728x90_2',
      size: [
        [728, 90],
        [970, 90],
        [800, 250],
        [970, 250],
      ],
    },
    Rectangle01: {
      isLazyLoaded: true,
      id: 'div-gpt-ad-1407836094561-0',
      adUnitPath: '/53015287,23277432748/xing.com_m_300x250_2',
      size: [
        [300, 250],
        [300, 50],
        [300, 75],
        [300, 100],
        [320, 250],
        [336, 280],
      ],
    },
    Rectangle02: {
      isLazyLoaded: true,
      id: 'div-gpt-ad-1407836287157-0',
      adUnitPath: '/53015287,23277432748/xing.com_m_300x250_3',
      size: [
        [300, 250],
        [300, 50],
        [300, 75],
        [300, 100],
        [320, 250],
        [336, 280],
      ],
    },
  },
  Profile: {
    Leaderboard: {
      id: 'div-gpt-ad-1407836215582-0',
      adUnitPath: '/53015287,23277432748/xing.com_d_728x90_1',
      size: [
        [728, 90],
        [970, 90],
      ],
    },
    HalfpageStickyBig: {
      id: 'div-gpt-ad-1407836209939-0',
      adUnitPath: '/53015287,23277432748/xing.com_d_300x600_1',
      size: [
        [300, 600],
        [160, 600],
        [120, 600],
        [300, 250],
      ],
    },
    HalfpageStickySmall: {
      id: 'div-gpt-ad-1407836209939-0',
      adUnitPath: '/53015287,23277432748/xing.com_d_160x600_1',
      size: [
        [120, 600],
        [160, 600],
      ],
    },
    Rectangle: {
      isLazyLoaded: true,
      id: 'div-gpt-ad-1407836077801-0',
      adUnitPath: '/53015287,23277432748/xing.com_m_300x250_1',
      size: [
        [300, 250],
        [300, 50],
        [300, 75],
        [300, 100],
        [320, 250],
        [336, 280],
      ],
    },
  },
  Login: {
    Leaderboard: {
      id: 'div-gpt-ad-1407836223948-0',
      adUnitPath: '/53015287,23277432748/xing.com_d_728x90_3',
      size: [728, 90],
    },
  },
};
